import React, { useState, useEffect, useRef, use } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { listsetting1, setMiniViewIds, useropen } from '../../redux/userInfo';
import { open, close, loadingflas, listupdater } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Button from '../../component/Button';
import Select from '../../component/Select';
import Radios from '../../component/Radios';
import Input from '../../component/Input';
import ListsettingPop from '../../component/ListsettingPop';
import ProductDetailPop from '../../component/ProductDetailPop';
import ProductSendPop from '../../component/ProductSendPop';
import ProductTogetherPop from '../../component/ProductTogetherPop';
import QuetionSimpleWrite from '../../component/QuetionSimpleWrite';


// 신규 컴포넌트
import SelectClick from '../../component/SelectClick';
import PlusMinusBox from '../../component/PlusMinusBox';
import MiniPageList from './MiniPageList';
import MiniPageMap from './MiniPageMap';

// 신규 모듈
import { useMediaQuery } from 'react-responsive'
import { isMobile } from 'react-device-detect';


import { Map, DrawingManager, MarkerClusterer, MapMarker, CustomOverlayMap } from "react-kakao-maps-sdk"
import AddrSelector from '../../component/AddrSelector';
import * as APIS from "../../utils/service";

import {
    getMemberinfo, numFormat, useIntersectionObserver, polygon_point_check, filterItems, geKoreanNumber, koreaNumber,
    patternOnlyNum
} from "../../utils/utils";
import Checkbox from '../../component/Checkbox';
import consts from '../../libs/consts';
import ProductDetailwrite from '../../component/ProductDetailwrite';

const { kakao } = window;

export default function MiniPage({ navigation }) {
    // const { id } = useParams()
    // const idx = id.substring(0, id.length-10);
    //console.log(moment().unix(), idx);

    const location = useLocation();
    const company_phone = location?.pathname?.replace("/", "");

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const managerRef = useRef(null);
    const mapRef = useRef(null);
    const clusterer = useRef(null);
    const target = useRef(null);
    const leftdivref = useRef(null);

    const [showWarning, setShowWarning] = useState(false);

    const { configdata } = useSelector(s => s.configReducer);
    const { listupdate } = useSelector(s => s.popupReducer);
    const { userdata, companylogourl, miniViewIds } = useSelector(s => s.userInfo);

    // 반응형 설정
    const is830 = useMediaQuery({ query: "(max-width : 830px)" });
    const is520 = useMediaQuery({ query: "(max-width : 520px)" });


    const [customerlist, setcustomerlist] = useState([]);
    const [customerselect, setcustomerselect] = useState([]);


    // 임시
    const [selPosList, setselPosList] = useState([]);
    let statusArrs = [];
    configdata?.consts?.itemStatusConsts?.map((x, i) => {
        if (x?.idx * 1 === 98) {
            statusArrs.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'green', 'no', x?.idx], labels: x?.title, values: x?.idx });
        } else if (x?.idx * 1 === 1) {
            statusArrs.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'black', 'y', x?.idx], labels: x?.title, values: x?.idx });
        } else if (x?.idx * 1 === 2) {
            statusArrs.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'blue', 'y', x?.idx], labels: x?.title, values: x?.idx });
        } else if (x?.idx * 1 === 3) {
            statusArrs.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'red', 'y', x?.idx], labels: x?.title, values: x?.idx });
        } else {
            statusArrs.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'y', x?.idx], labels: x?.title, values: x?.idx });
        }
    });
    // {'set': ['접수', 'black', 'y'], '매물번호': '2153151', '접수일': '23/12/02', '확인일': '7일전', '읍/면,동': '성산동', '지번': '123-1', '전용': '17평', '종류': '월세', '가격': '4,000/210', '관리비': '60' },
    // {'set': ['간편', 'green', 'no'], '매물번호': '2153151', '접수일': '23/12/02', '확인일': '7일전', '읍/면,동': '성산동', '지번': '123-1', '전용': '17평', '종류': '월세', '가격': '4,000/210', '관리비': '60' },
    // {'set': ['임장', 'blue', 'y'], '매물번호': '2153151', '접수일': '23/12/02', '확인일': '7일전', '읍/면,동': '성산동', '지번': '123-1', '전용': '17평', '종류': '월세', '가격': '4,000/210', '관리비': '60' },
    // {'set': ['보류', 'red', 'y'], '매물번호': '2153151', '접수일': '23/12/02', '확인일': '7일전', '읍/면,동': '성산동', '지번': '123-1', '전용': '17평', '종류': '월세', '가격': '4,000/210', '관리비': '60' },
    // {'set': ['의뢰', 'orange', 'no'], '매물번호': '2153151', '접수일': '23/12/02', '확인일': '7일전', '읍/면,동': '성산동', '지번': '123-1', '전용': '17평', '종류': '월세', '가격': '4,000/210', '관리비': '60' },
    // {'set': ['완료', 'gray', 'y'], '매물번호': '2153151', '접수일': '23/12/02', '확인일': '7일전', '읍/면,동': '성산동', '지번': '123-1', '전용': '17평', '종류': '월세', '가격': '4,000/210', '관리비': '60' },

    const statusName = statusArrs;

    // const { seltypes, category_1s, 
    //     listset1, 
    //     listset2, 
    //     listset3, 
    //     listset1_2, 
    //     listset2_2, 
    //     listset3_2, 
    //     listset1_3, 
    //     listset2_3, 
    //     listset3_3, 
    // } = useSelector(state => state.userInfo);

    const width = window.innerWidth;
    const height = window.innerHeight;
    // 건물 idx 리스트
    const cateGunmulIdxs = [9, 10, 11];

    // 신규 state
    const [listShow, setListShow] = useState(is830 ? false : true);
    const [easyWrite, seteasyWrite] = useState(false);
    const [latlng, setlatlng] = useState({ lat: 33.450701, lng: 126.570667 });
    const [positions, setpositions] = useState([]); // 맵 좌표들

    // 매물 종류
    const [configArr, setConfigArr] = useState([]);

    // 거래 유형/가격
    const [sell_type, setsell_type] = useState(''); // 매매 전세 월세
    const [sell_type_list, setsell_type_list] = useState([]); // 매매 전세 월세
    const [price_sell_min, setprice_sell_min] = useState(0); // 매매가 최소
    const [price_sell_max, setprice_sell_max] = useState(0); // 매매가 최대
    const [price_all_min, setprice_all_min] = useState(0); // 전세 보증금 최소
    const [price_all_max, setprice_all_max] = useState(0); // 전세 보증금 최대
    const [price_all_month_min, setprice_all_month_min] = useState(0); // 월세 보증금 최소
    const [price_all_month_max, setprice_all_month_max] = useState(0); // 월세 보증금 최대
    const [price_month_min, setprice_month_min] = useState(0); // 월세 최소
    const [price_month_max, setprice_month_max] = useState(0); // 월세 최대

    // 면적, 방수, 층
    const [area_type, setarea_type] = useState(1); // 1=평, 2=m²
    const [area_private_min, setarea_private_min] = useState(0); // 전용면적 최소
    const [area_private_max, setarea_private_max] = useState(0); // 전용면적 최대
    const [item_room, setitem_room] = useState(0); // 방수 1=1개, 2=2개, 3=3개, 4=4개 이상
    const [item_room_list, setitem_room_list] = useState([]); // 방수 선택 array (중복선택 가능기능)
    const [building_floor_min, setbuilding_floor_min] = useState(0); // 희망층 최소
    const [building_floor_max, setbuilding_floor_max] = useState(0); // 희망층 최대


    const [building_floor_arr, setbuilding_floor_arr] = useState([]); // 희망층 idx 배열

    
    const [area_floor_min, setarea_floor_min] = useState(0); // 건물 연면적 최소
    const [area_floor_max, setarea_floor_max] = useState(0); // 건물 연면적 최대
    const [area_land_min, setarea_land_min] = useState(0); // 토지면적 최소
    const [area_land_max, setarea_land_max] = useState(0); // 토지면적 최대
    const [building_dong_floor_all_min, setbuilding_dong_floor_all_min] = useState(0); // 희망 총 층수 최소
    const [building_dong_floor_all_max, setbuilding_dong_floor_all_max] = useState(0); // 희망 총 층수 최대


    const [memberinfos, setmemberinfos] = useState('');
    const [saveproductlistTd, setsaveproductlistTd] = useState([]);  // 기존에 가지고 있는거
    const [productlistTd, setproductlistTd] = useState([]); // 가공된 애들


    const MIN_WIDTH = width / 2;
    const [lists, setlists] = useState([]);
    const [searchvar, setsearchvar] = useState('');
    const [selectorderby, setselectorderby] = useState('');

    const [pricemin, setpricemin] = useState('');
    const [pricemax, setpricemax] = useState('');
    const [areamin, setareamin] = useState('');
    const [areamax, setareamax] = useState('');

    const [polygons, setpolygons] = useState([]);
    const [seldamdang, setseldamdang] = useState(0);
    const [damdanglist, setdamdanglist] = useState([]);

    
    // 미니홈 설정 state
    const [listType, setListType] = useState(1);
    const [viewType, setViewType] = useState(2);
    const [load, setLoad] = useState(true);

    useEffect(() => {
        if (!miniViewIds) {
            dispatch(setMiniViewIds(0))
        }
    }, []);

    // 좌표값 가져오기
    const getAddressToGeoCode = (address, callback) => {
        const geocoder = new window.kakao.maps.services.Geocoder();
        geocoder.addressSearch(address, function (result, status) {
            if (status === window.kakao.maps.services.Status.OK) {
                const coords = new window.kakao.maps.LatLng(result[0].y, result[0].x);
                callback({ lat: result[0].y, lng: result[0].x })
            }
        });
    }

    useEffect(() => {
        if (memberinfos?.compony?.addr) {
            let address = memberinfos?.compony?.addr;

            getAddressToGeoCode(address, (geoCode) => {
                setlatlng(geoCode)
            })

            if (memberinfos?.compony?.minicategory_2 * 1 !== 0) {
                // console.log('초기 설정 :: >> ', memberinfos?.compony?.minicategory_2?.split(",").map(v => v * 1));
                // 관리자에서 미니홈 초기 세팅값이 있으면 확인하고 저장
                setConfigArr(memberinfos?.compony?.minicategory_2?.split(",").map(v => v * 1));
            } else {
                // 전체선택
                const cate1 = Number(memberinfos?.compony?.minicategory_1)
                const filterOption = configdata?.consts?.category_2_OptionConsts.filter(v => v.category_1 === cate1)

                if (cate1 !== 0) {
                    // 초기 설정 저장
                    setConfigArr(filterOption.map(v => v.idx))
                } else {
                    setConfigArr([])
                }
            }
        }
    }, [memberinfos]);

    useEffect(() => {
        setLoad(false);
    }, []);

    useEffect(() => {
        if(load) return;
        filterFunc();
    }, [listType]);


    const filterFunc = () => {
        // 모든 리스트
        let oriList = saveproductlistTd?.filter(x => x.lat != 0 && x.lng != 0);

        if (configArr?.length > 0) {
            // console.log(configArr);
            oriList = oriList?.filter(x => configArr.includes(x?.category_2))
        }

        // 거래 유형 가격
        if (sell_type_list.length > 0) {
            let sellTypeFindList = []
            if (sell_type_list.filter(v => v.values == '매매').length > 0) {
                const selItemList = oriList?.filter(x => x?.sell_type === "매매");
                if (price_sell_max) {
                    sellTypeFindList = sellTypeFindList.concat(selItemList?.filter(x => ((x?.price_sell * 1) >= (price_sell_min / 10000) && (x?.price_sell * 1) <= (price_sell_max / 10000))))
                } else {
                    sellTypeFindList = sellTypeFindList.concat(selItemList?.filter(x => ((x?.price_sell * 1) >= (price_sell_min / 10000))))
                }
            }

            if (sell_type_list.filter(v => v.values == '전세').length > 0) {
                const selItemList = oriList?.filter(x => x?.sell_type === "전세");
                if (price_all_max) {
                    sellTypeFindList = sellTypeFindList.concat(selItemList?.filter(x => ((x?.price_all * 1) >= (price_all_min / 10000) && (x?.price_all * 1) <= (price_all_max / 10000))));
                } else {
                    sellTypeFindList = sellTypeFindList.concat(selItemList?.filter(x => ((x?.price_all * 1) >= (price_all_min / 10000))));
                }
            }
            if (sell_type_list.filter(v => v.values == '월세').length > 0) {
                let monthItemList = oriList?.filter(x => x?.sell_type === "월세");

                if (price_all_month_max) {
                    monthItemList = monthItemList?.filter(x => ((x?.price_all * 1) >= (price_all_month_min / 10000) && (x?.price_all * 1) <= (price_all_month_max / 10000)));
                } else {
                    monthItemList = monthItemList?.filter(x => ((x?.price_all * 1) >= (price_all_month_min / 10000)));
                }

                if (price_month_max) {
                    monthItemList = monthItemList?.filter(x => ((x?.price_month * 1) >= (price_month_min / 10000) && (x?.price_month * 1) <= (price_month_max / 10000)));
                } else {
                    monthItemList = monthItemList?.filter(x => ((x?.price_month * 1) >= (price_month_min / 10000)));
                }
                sellTypeFindList = sellTypeFindList.concat(monthItemList);
            }

            oriList = sellTypeFindList;
        }

        // 면적
        if (area_private_max) {
            if (area_type === 1) { // 평수
                oriList = oriList?.filter(x => {
                    if (cateGunmulIdxs.includes(x?.category_2)) {
                        return true; // 건물일경우 필터링 패스 - j
                    }
                    return ((x?.area_private * 0.3025) >= (area_private_min) && (x?.area_private * 0.3025) <= (area_private_max))
                });
            } else { // m²
                oriList = oriList?.filter(x => {
                    if (cateGunmulIdxs.includes(x?.category_2)) {
                        return true; // 건물일경우 필터링 패스 - j
                    }
                    return ((x?.area_private * 1) >= (area_private_min) && (x?.area_private * 1) <= (area_private_max))
                });
            }
        } else {
            if (area_type === 1) { // 평수
                oriList = oriList?.filter(x => {
                    if (cateGunmulIdxs.includes(x?.category_2)) {
                        return true; // 건물일경우 필터링 패스 - j
                    }
                    return ((x?.area_private * 0.3025) >= (area_private_min))
                });
            } else { // m²
                oriList = oriList?.filter(x => {
                    if (cateGunmulIdxs.includes(x?.category_2)) {
                        return true; // 건물일경우 필터링 패스 - j
                    }
                    return ((x?.area_private * 1) >= (area_private_min))
                });
            }
        }

        // 방 개수
        // if (item_room) {
        //     if (item_room >= 4) {
        //         oriList = oriList?.filter(x => ((x?.item_room * 1) >= item_room));
        //     } else {
        //         oriList = oriList?.filter(x => ((x?.item_room * 1) === item_room));
        //     }
        // }
        
        if (item_room_list.length > 0) {
            oriList = oriList?.filter(x => {
                if (cateGunmulIdxs.includes(x?.category_2)) {
                    return true; // 건물일경우 필터링 패스 - j
                } else {
                    if (item_room_list.includes(4)) {
                        if (item_room_list.includes(x?.item_room * 1) || (x?.item_room * 1) > 4) {
                            return true;
                        }
                    } else {
                        if (item_room_list.includes(x?.item_room * 1)) {
                            return true;
                        }
                    }
                    return false
                }
            });
        }

        // 희망층
        if (building_floor_arr?.length) { // 250414 building_floor_max 조건에서 변경
            oriList = oriList?.filter(x => {
                if (cateGunmulIdxs.includes(x?.category_2)) {
                    return true; // 건물일경우 필터링 패스 - j
                }

                // console.log('민 > ', building_floor_min);
                // console.log('맥스 > ', building_floor_max);
                // console.log('현재층 > ', (x?.building_floor?.replace(patternOnlyNum, "") * 1));
                // console.log('맥스층 > ', (x?.building_floor_all?.replace(patternOnlyNum, "") * 1));
                // console.log('동층 > ', (x?.building_dong_floor_all?.replace(patternOnlyNum, "") * 1));

                // console.log(building_floor_arr);

                // idx: 0, title: '전체', min: 0, max: 0,
                // idx: 1, title: '1층', min: 1, max: 1
                // idx: 2, title: '저층', min: 1, max: 33.33
                // idx: 3, title: '중간층', min: 33.34, max: 66.66
                // idx: 4, title: '고층', min: 66.67, max: 100
                // idx: 5, title: '탑층', min: 100, max: 100

                if(x?.building_floor && (x?.building_floor_all || x?.building_dong_floor_all)) {
                    
                    let floorAll = x?.building_dong_floor_all;
                    if(!x?.building_dong_floor_all) floorAll = x?.building_floor_all;
                    let floorPer = (x?.building_floor?.replace(patternOnlyNum, "") * 1) / (floorAll?.replace(patternOnlyNum, "") * 1) * 100;
                    floorPer = Math.floor(floorPer);

                    if(
                        (building_floor_arr?.includes(1) && x?.building_floor?.replace(patternOnlyNum, "") * 1 === 1) || // 1층일때 조건
                        (building_floor_arr?.includes(2) && floorPer >= 1 && floorPer <= 33.33) || // 저층
                        (building_floor_arr?.includes(3) && floorPer >= 33.34 && floorPer <= 66.66) || // 중간층
                        (building_floor_arr?.includes(4) && floorPer >= 66.67 && floorPer <= 100) || // 고층
                        (building_floor_arr?.includes(5) && (x?.building_floor?.replace(patternOnlyNum, "") * 1 === floorAll?.replace(patternOnlyNum, "") * 1)) // 탑층일때
                    ) {
                        return true;
                    }

                    // if((building_floor_min === 1 && building_floor_max === 1) && x?.building_floor?.replace(patternOnlyNum, "") * 1 === 1 ){ 
                    //     console.log('난 1층')
                    //     // 1층일때 조건
                    //     return true;
                    // }else if((building_floor_min === 100 && building_floor_max === 100) && (x?.building_floor?.replace(patternOnlyNum, "") * 1 === floorAll?.replace(patternOnlyNum, "") * 1)) { 
                    //     console.log('난 탑층')
                    //     // 탑층일때 조건
                    //     return true;
                    // } else {
                    //     console.log('난 그거')
                    //     return floorPer >= building_floor_min && floorPer <= building_floor_max;
                    // }

                } else {
                    return false;
                }
            });
        } else {
            oriList = oriList?.filter(x => {
                if (cateGunmulIdxs.includes(x?.category_2)) {
                    return true; // 건물일경우 필터링 패스 - j
                }
                return ((x?.building_floor.replace(patternOnlyNum, "") * 1) >= building_floor_min)
            });
        }

        //건물일경우에 연면적/희망총층수 적용
        if (configArr.filter(conf => cateGunmulIdxs.includes(conf)).length > 0) {
            // 건물 연면적
            console.log("연면적", oriList.length)
            if (area_floor_max) {
                oriList = oriList?.filter(x => {
                    if (cateGunmulIdxs.includes(x?.category_2)) {
                        if (area_type === 1)  // 평수
                            return ((x?.area_floor * 0.3025) >= area_floor_min && (x?.area_floor * 0.3025) <= area_floor_max)
                        else
                            return ((x?.area_floor * 1) >= area_floor_min && (x?.area_floor * 1) <= area_floor_max)
                    } else {
                        return true;
                    }
                });
            } else {
                oriList = oriList?.filter(x => {
                    if (cateGunmulIdxs.includes(x?.category_2)) {
                        if (area_type === 1)
                            return ((x?.area_floor * 0.3025) >= area_floor_min)
                        else
                            return ((x?.area_floor * 1) >= area_floor_min)
                    } else {
                        return true;
                    }
                });
            }
            // console.log("연면적2", oriList.length)

            // 토지면적
            if (area_land_max) {
                oriList = oriList?.filter(x => {
                    if (cateGunmulIdxs.includes(x?.category_2)) {
                        if (area_type === 1)
                            return ((x?.area_land * 0.3025) >= area_land_min && (x?.area_land * 0.3025) <= area_land_max)
                        else
                            return ((x?.area_land * 1) >= area_land_min && (x?.area_land * 1) <= area_land_max)
                    } else {
                        return true
                    }
                });
            } else {
                oriList = oriList?.filter(x => {
                    if (cateGunmulIdxs.includes(x?.category_2)) {
                        if (area_type === 1)
                            return ((x?.area_land * 0.3025) >= area_land_min)
                        else
                            return ((x?.area_land * 1) >= area_land_min)
                    } else {
                        return true
                    }
                });
            }

            // 희망 총 층수
            if (building_dong_floor_all_max) {
                oriList = oriList?.filter(x => {
                    if (cateGunmulIdxs.includes(x?.category_2)) {
                        return ((x?.building_dong_floor_all * 1) >= building_dong_floor_all_min && (x?.building_dong_floor_all * 1) <= building_dong_floor_all_max)
                    } else {
                        return true
                    }
                });
            } else {
                console.log("희망 총 층수", oriList.length)
                oriList = oriList?.filter(x => {
                    if (cateGunmulIdxs.includes(x?.category_2)) {
                        return ((x?.building_dong_floor_all * 1) >= building_dong_floor_all_min)
                    } else {
                        return true
                    }
                });
            }
        }

        if(listType === 2) { // 등록순
            oriList = oriList.sort(function(a, b) {
                return new Date(b?.create_dt).getTime() - new Date(a?.create_dt).getTime();
            });
        } else if(listType === 3) { // 가격순
            
            // console.log('>>>>>> ', sell_type_list);

            oriList = oriList.sort(function(a, b) {
                let aPrice = a?.price_sell ? a?.price_sell : a?.price_all ? a?.price_all : a?.price_month;
                let bPrice = b?.price_sell ? b?.price_sell : b?.price_all ? b?.price_all : b?.price_month;

                return aPrice - bPrice;
                // return bPrice - aPrice;
            });

            // 매매일때는 price_sell <= 매매 컬럼 사용
            // 전세일때는 price_all <= 전세 컬럼 사용
            // 월세일때는 price_month <= 월세 컬럼 사용

        } else if(listType === 4) { // 면적순
            
            oriList = oriList.sort(function(a, b) {
                let bArea = b?.area_floor;
                if(!b?.area_floor) bArea = b?.area_private;
                let aArea = a?.area_floor;
                if(!a?.area_floor) aArea = a?.area_private;

                return bArea - aArea;
            });
            // 250411 => 전용면적에서 연면적 기준으로 변경
            // area_floor => 연면적
            // area_private => 전용면적
        } else { // 기본순

            // let miniViewIds_reverse = miniViewIds;
            // let miniViewIds_reverse = miniViewIds?.reverse();
            // console.log('리버스 :: ', miniViewIds_reverse);
            
            oriList = oriList.sort(function(a, b) {
                const aInMiniView = miniViewIds?.includes(a.idx);
                const bInMiniView = miniViewIds?.includes(b.idx);

                if (aInMiniView === bInMiniView) {
                    return new Date(a?.update_dt)?.getTime() - new Date(b?.update_dt)?.getTime();
                }

                return aInMiniView ? -1 : 1;
            });
        }

        // console.log('ori >', oriList?.length);
        
        setproductlistTd(oriList);

        if(oriList?.length > 0) {
            let clustorlist = [];

            oriList?.map((x, i) => {
                clustorlist.push(
                    {
                        idx: x['idx'] * 1,
                        lat: x['lat'] * 1,
                        lng: x['lng'] * 1
                    }
                );
            });
            
            // console.log('clurList: ', clustorlist);
            // console.log('clurCount: ', clustorlist?.length);
            //setTimeout(() => {
                setpositions(clustorlist);
            //}, 2000);
        } else {
            setpositions([{}]);
        }
        
    }

    const mapFilterClurFunc = (list) => {
        // 모든 리스트
        let oriList = saveproductlistTd?.filter(x => x.lat != 0 && x.lng != 0);

        if (configArr?.length > 0) {
            // console.log(configArr);
            oriList = oriList?.filter(x => configArr.includes(x?.category_2))
        }

        // 거래 유형 가격
        if (sell_type_list.length > 0) {
            let sellTypeFindList = []
            if (sell_type_list.filter(v => v.values == '매매').length > 0) {
                const selItemList = oriList?.filter(x => x?.sell_type === "매매");
                if (price_sell_max) {
                    sellTypeFindList = sellTypeFindList.concat(selItemList?.filter(x => ((x?.price_sell * 1) >= (price_sell_min / 10000) && (x?.price_sell * 1) <= (price_sell_max / 10000))))
                } else {
                    sellTypeFindList = sellTypeFindList.concat(selItemList?.filter(x => ((x?.price_sell * 1) >= (price_sell_min / 10000))))
                }
            }

            if (sell_type_list.filter(v => v.values == '전세').length > 0) {
                const selItemList = oriList?.filter(x => x?.sell_type === "전세");
                if (price_all_max) {
                    sellTypeFindList = sellTypeFindList.concat(selItemList?.filter(x => ((x?.price_all * 1) >= (price_all_min / 10000) && (x?.price_all * 1) <= (price_all_max / 10000))));
                } else {
                    sellTypeFindList = sellTypeFindList.concat(selItemList?.filter(x => ((x?.price_all * 1) >= (price_all_min / 10000))));
                }
            }

            if (sell_type_list.filter(v => v.values == '월세').length > 0) {
                let monthItemList = oriList?.filter(x => x?.sell_type === "월세");
                if (price_all_month_max) {
                    monthItemList = monthItemList?.filter(x => ((x?.price_all * 1) >= (price_all_month_min / 10000) && (x?.price_all * 1) <= (price_all_month_max / 10000)));
                } else {
                    monthItemList = monthItemList?.filter(x => ((x?.price_all * 1) >= (price_all_month_min / 10000)));
                }

                if (price_month_max) {
                    monthItemList = monthItemList?.filter(x => ((x?.price_month * 1) >= (price_month_min / 10000) && (x?.price_month * 1) <= (price_month_max / 10000)));
                } else {
                    monthItemList = monthItemList?.filter(x => ((x?.price_month * 1) >= (price_month_min / 10000)));
                }
                sellTypeFindList = sellTypeFindList.concat(monthItemList);
            }

            oriList = sellTypeFindList;
        }
        // sell_type 을 리스트로 변경하면서 사용 안함
        if (sell_type && false) {
            // 필터된 리스트 저장
            oriList = oriList?.filter(x => x?.sell_type === sell_type);

            if (sell_type === '매매') {
                if (price_sell_max) {
                    oriList = oriList?.filter(x => ((x?.price_sell * 1) >= (price_sell_min / 10000) && (x?.price_sell * 1) <= (price_sell_max / 10000)));
                } else {
                    oriList = oriList?.filter(x => ((x?.price_sell * 1) >= (price_sell_min / 10000)));
                }
            }
            if (sell_type === '전세') {
                if (price_all_max) {
                    oriList = oriList?.filter(x => ((x?.price_all * 1) >= (price_all_min / 10000) && (x?.price_all * 1) <= (price_all_max / 10000)));
                } else {
                    oriList = oriList?.filter(x => ((x?.price_all * 1) >= (price_all_min / 10000)));
                }
            }
            if (sell_type === '월세') {
                if (price_all_month_max) {
                    oriList = oriList?.filter(x => ((x?.price_all * 1) >= (price_all_month_min / 10000) && (x?.price_all * 1) <= (price_all_month_max / 10000)));
                } else {
                    oriList = oriList?.filter(x => ((x?.price_all * 1) >= (price_all_month_min / 10000)));
                }
                if (price_month_max) {
                    oriList = oriList?.filter(x => ((x?.price_month * 1) >= (price_month_min / 10000) && (x?.price_month * 1) <= (price_month_max / 10000)));
                } else {
                    oriList = oriList?.filter(x => ((x?.price_month * 1) >= (price_month_min / 10000)));
                }
            }
        }


        // 면적
        if (area_private_max) {
            if (area_type === 1) { // 평수
                oriList = oriList?.filter(x => ((x?.area_private * 0.3025) >= (area_private_min) && (x?.area_private * 0.3025) <= (area_private_max)));
            } else { // m²
                oriList = oriList?.filter(x => ((x?.area_private * 1) >= (area_private_min) && (x?.area_private * 1) <= (area_private_max)));
            }
        } else {
            if (area_type === 1) { // 평수
                oriList = oriList?.filter(x => ((x?.area_private * 0.3025) >= (area_private_min)));
            } else { // m²
                oriList = oriList?.filter(x => ((x?.area_private * 1) >= (area_private_min)));
            }
        }

        // 방 개수
        if (item_room) {
            if (item_room >= 4) {
                oriList = oriList?.filter(x => ((x?.item_room * 1) >= item_room));
            } else {
                oriList = oriList?.filter(x => ((x?.item_room * 1) === item_room));
            }
        }

        // if (building_floor_max) {
        //     oriList = oriList?.filter(x => ((x?.building_floor?.replace(patternOnlyNum, "") * 1) >= building_floor_min && (x?.building_floor.replace(patternOnlyNum, "") * 1) <= building_floor_max));
        // } else {
        //     oriList = oriList?.filter(x => ((x?.building_floor.replace(patternOnlyNum, "") * 1) >= building_floor_min));
        // }
                
        // 희망층
        if (building_floor_arr?.length) { // 250414 building_floor_max 조건에서 변경
            oriList = oriList?.filter(x => {
                if (cateGunmulIdxs.includes(x?.category_2)) {
                    return true; // 건물일경우 필터링 패스 - j
                }

                if(x?.building_floor && (x?.building_floor_all || x?.building_dong_floor_all)) {
                    
                    let floorAll = x?.building_dong_floor_all;
                    if(!x?.building_dong_floor_all) floorAll = x?.building_floor_all;
                    let floorPer = (x?.building_floor?.replace(patternOnlyNum, "") * 1) / (floorAll?.replace(patternOnlyNum, "") * 1) * 100;
                    floorPer = Math.floor(floorPer);

                    if(
                        (building_floor_arr?.includes(1) && x?.building_floor?.replace(patternOnlyNum, "") * 1 === 1) || // 1층일때 조건
                        (building_floor_arr?.includes(2) && floorPer >= 1 && floorPer <= 33.33) || // 저층
                        (building_floor_arr?.includes(3) && floorPer >= 33.34 && floorPer <= 66.66) || // 중간층
                        (building_floor_arr?.includes(4) && floorPer >= 66.67 && floorPer <= 100) || // 고층
                        (building_floor_arr?.includes(5) && (x?.building_floor?.replace(patternOnlyNum, "") * 1 === floorAll?.replace(patternOnlyNum, "") * 1)) // 탑층일때
                    ) {
                        return true;
                    }
                    
                    // if((building_floor_min === 1 && building_floor_max === 1) && x?.building_floor?.replace(patternOnlyNum, "") * 1 === 1 ){ 
                    //     // 1층일때 조건
                    //     return true;
                    // }else if((building_floor_min === 100 && building_floor_max === 100) && (x?.building_floor?.replace(patternOnlyNum, "") * 1 === floorAll?.replace(patternOnlyNum, "") * 1)) { 
                    //     // 탑층일때 조건
                    //     return true;
                    // } else {
                    //     return floorPer >= building_floor_min && floorPer <= building_floor_max;
                    // }
                } else {
                    return false;
                }
            });
        } else {
            oriList = oriList?.filter(x => {
                if (cateGunmulIdxs.includes(x?.category_2)) {
                    return true; // 건물일경우 필터링 패스 - j
                }
                return ((x?.building_floor.replace(patternOnlyNum, "") * 1) >= building_floor_min)
            });
        }

        //건물일경우에 연면적/희망총층수 적용
        if (configArr.filter(conf => cateGunmulIdxs.includes(conf)).length > 0) {
            // 건물 연면적
            if (area_floor_max) {
                oriList = oriList?.filter(x => {
                    if (cateGunmulIdxs.includes(x?.category_2)) {
                        if (area_type === 1)  // 평수
                            return ((x?.area_floor * 0.3025) >= area_floor_min && (x?.area_floor * 0.3025) <= area_floor_max)
                        else
                            return ((x?.area_floor * 1) >= area_floor_min && (x?.area_floor * 1) <= area_floor_max)
                    } else {
                        return false;
                    }
                });
            } else {
                oriList = oriList?.filter(x => {
                    if (cateGunmulIdxs.includes(x?.category_2)) {
                        if (area_type === 1)
                            return ((x?.area_floor * 0.3025) >= area_floor_min)
                        else
                            return ((x?.area_floor * 1) >= area_floor_min)
                    } else {
                        return false;
                    }
                });
            }

            // 토지면적
            if (area_land_max) {
                oriList = oriList?.filter(x => {
                    if (cateGunmulIdxs.includes(x?.category_2)) {
                        if (area_type === 1)
                            return ((x?.area_land * 0.3025) >= area_land_min && (x?.area_land * 0.3025) <= area_land_max)
                        else
                            return ((x?.area_land * 1) >= area_land_min && (x?.area_land * 1) <= area_land_max)
                    } else {
                        return false
                    }
                });
            } else {
                oriList = oriList?.filter(x => {
                    if (cateGunmulIdxs.includes(x?.category_2)) {
                        if (area_type === 1)
                            return ((x?.area_land * 0.3025) >= area_land_min)
                        else
                            return ((x?.area_land * 1) >= area_land_min)
                    } else {
                        return false
                    }
                });
            }

            // 희망 총 층수
            if (building_dong_floor_all_max) {
                oriList = oriList?.filter(x => {
                    if (cateGunmulIdxs.includes(x?.category_2)) {
                        return ((x?.building_dong_floor_all * 1) >= building_dong_floor_all_min && (x?.building_dong_floor_all * 1) <= building_dong_floor_all_max)
                    } else {
                        return false
                    }
                });
            } else {
                oriList = oriList?.filter(x => {
                    if (cateGunmulIdxs.includes(x?.category_2)) {
                        return ((x?.building_dong_floor_all * 1) >= building_dong_floor_all_min)
                    } else {
                        return false
                    }
                });
            }
        }

        if (list?.length > 0) {
            // console.log(oriList)
            oriList = oriList?.filter(x => list.includes(x?.idx))
        }

        setproductlistTd(oriList);


        if (is830) {
            setListShow(true);
        }
    }

    let firstCategorys = configdata?.consts?.category_1_OptionConsts?.find((x, i) => i === 0)?.idx;

    const [category_1, setcategory_1] = useState(firstCategorys);
    const [category_2, setcategory_2] = useState(configdata?.consts?.category_2_OptionConsts?.find((x, i) => (x?.category_1 === firstCategorys && i === 0))?.idx);
    const [checkvalues, setcheckvalues] = useState([]);
    const [listselecterviewerlist, setlistselecterviewerlist] = useState([]);
    const [polystatus, setpolystatus] = useState(false);
    const [listsetpopstatus, setlistsetpopstatus] = useState(false);
    const [detailwrite, setdetailwrite] = useState(false);
    const [listDataAll, setlistDataAll] = useState([]);
    const [mapViewerflag, setmapViewerflag] = useState(false);
    const [page, setPage] = useState(0);


    const [listloading, setlistloading] = useState(false);
    const [updatestatus, setupdatestatus] = useState(false);
    const [loadingstep, setloadingstep] = useState(0);

    useEffect(() => {
        if (loadingstep === 0) {
            dispatch(loadingflas({ loading: true }));
            let sender = {}
            APIS.postData('/v1/master/users', sender).then(({ data }) => {
                if (data) {
                    //setdamdanglist(data);
                    //console.log(data);
                    let damdanglistArr = [];
                    data?.map((x, i) => {
                        damdanglistArr.push({ labels: `${x?.name} ${x?.rank}`, values: x?.idx });
                    })
                    setdamdanglist(damdanglistArr);
                    setTimeout(() => {
                        setloadingstep(1);
                        // }, 200);
                    }, 50);
                }
            }).catch(({ response }) => {
                const { data } = response;
                setTimeout(() => {
                    setloadingstep(1);
                    // }, 200);
                }, 50);
            }).finally(() => {
            });
        }

        if (loadingstep === 1) {
            // observe(target.current);

            setTimeout(() => {
                setloadingstep(2);
                // }, 200);
            }, 50);
        }

        if (loadingstep === 2) {
            console.log('함수 실행 ~~');
            setloadingstep(3);
        }

        if (loadingstep === 3) {
            setTimeout(() => {
                // dispatch(loadingflas({ loading: false }));
                listopen();
                // }, 200);
            }, 50);
        }
    }, [loadingstep]);

    useEffect(() => {
        if (loadingstep === 4) {
            setloadingstep(1);
        }

        // window.addEventListener("beforeunload", function (event) {
        //     event.preventDefault();
        // });

    }, []);

    useEffect(() => {
        if (loadingstep === 4) {
            if (updatestatus === true) {
                setloadingstep(3);
            }
        }
    }, [updatestatus]);

    const listopen = () => {

        dispatch(loadingflas({ loading: true }));
        //alert(company_phone);
        let sender = {
            company_phone: company_phone
        }

        APIS.postData('/v1/item/companylist', sender).then(({ data }) => {
            let datas = data?.list;
            let customers = data?.customers;
            // console.log("data?.usersdata?.usersdata?.usersdata?.users", data?.users);
            setmemberinfos(data?.users);
            setcustomerlist(customers?.filter(item => item?.u_idx === memberinfos?.idx));

            if (datas) {
                
                // 원본 저장
                // 250411 수정, jp_item_send 점포거래서 연동 => 0=미연동, 1=연동, 관리자에서 외부공개 on/off 로 사용
                setsaveproductlistTd(datas?.filter(x => x?.jp_item_send));

                // 필터된 리스트 저장
                setproductlistTd(datas);

                // 좌표 담기
                let clustorlist = [];
                datas?.map((x, i) => {
                    clustorlist.push(
                        {
                            idx: x['idx'] * 1,
                            lat: x['lat'] * 1,
                            lng: x['lng'] * 1
                        }
                    );
                });

                // console.log('listopen 함수 실행 !!');
                setpositions(clustorlist);
            }

        }).catch(({ response }) => {
            //const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }


    const mobileBackControl = (menu) => {
        // console.log('menu : ' , menu);

        if(menu == 'list') {
            window.location.href = `#list`
        }
    }

    useEffect(() => {
        // console.log('MiniPage >> ',location);

        if (!location.hash && isMobile) {
            setListShow(false);
        } else {
            let menuType = location.hash.replace("#", '');
            menuType = menuType.replace("detail", '');

            console.log('type >>>>>>> ', menuType);

            if(menuType === 'list') {
                setListShow(true);
            }

            // if (!isNaN(cardIdx)) {
            //     let findIndex = list.findIndex(v => v.idx == cardIdx)
            //     if (findIndex >= 0) {
            //         setdetail(list[findIndex]);
            //     } else {
            //         setdetail('');
            //     }
            // }
        }
    }, [location]);


    let floor_config = [
        {
            idx: 0,
            title: '전체',
            min: 0,
            max: 0,
        },
        {
            idx: 1,
            title: '1층',
            min: 1,
            max: 1
        },
        {
            idx: 2,
            title: '저층',
            min: 1,
            max: 33.33
        },
        {
            idx: 3,
            title: '중간층',
            min: 33.34,
            max: 66.66
        },
        {
            idx: 4,
            title: '고층',
            min: 66.67,
            max: 100
        },
        {
            idx: 5,
            title: '탑층',
            min: 100,
            max: 100
        },
    ]


    return (
        <>
            <div className='mini_home_container'>
                <>
                    {listShow &&
                        <div className={is830 ? 'list_mini_popup' : 'list_mini_popup_not'}>
                            {is830 ?
                                <>
                                    <div className='close_btn'>
                                        <img src="./images/icons/icon_arrow_back.svg" width='24'
                                            onClick={() => {
                                                setlatlng(v => ({ ...v }))
                                                if(isMobile) {
                                                    navigate(-1);
                                                } else {
                                                    setListShow(!listShow);
                                                }
                                            }}
                                        />
                                        
                                        <p className='mini_header_title'>
                                            {memberinfos?.compony?.title}
                                        </p>

                                        <div style={{ width: is520 ? 65 : 65, flexShrink: 0 }}>
                                            <Button
                                                styles={{ width: 65, height: 28, fontSize: 14 }}
                                                className={'normalbutton_middle'}
                                                buttonTxt={memberinfos?.compony?.miniorderbuttonText || '간편문의'}
                                                onPress={() => {
                                                    seteasyWrite(!easyWrite);
                                                }}

                                            />
                                        </div>
                                    </div>

                                    <div className='select_type_list'>
                                        <div className='flex_list_type'>
                                            <p className={listType === 1 ? 'active' : ''} onClick={() => {
                                                setListType(1);
                                            }}>기본순</p>
                                            <div className='bar_icon_div' />
                                            <p className={listType === 2 ? 'active' : ''} onClick={() => {
                                                setListType(2);
                                            }}>등록순</p>
                                            <div className='bar_icon_div' />
                                            <p className={listType === 3 ? 'active' : ''} onClick={() => {
                                                setListType(3);
                                            }}>가격순</p>
                                            <div className='bar_icon_div' />
                                            <p className={listType === 4 ? 'active' : ''} onClick={() => {
                                                setListType(4);
                                            }}>면적순</p>
                                        </div>

                                        <div className='icon_img_type'>
                                            <div
                                                className='icon_box'
                                                onClick={() => {
                                                    setViewType(1);
                                                }}
                                            >
                                                {viewType === 1 ? 
                                                    <img src="./images/icons/icon_view_list_active.svg" width='18'/>
                                                    :
                                                    <img src="./images/icons/icon_view_list.svg" width='18'/>
                                                }
                                            </div>
                                            <div className='bar_icon_div' />
                                            <div
                                                className='icon_box'
                                                onClick={() => {
                                                    setViewType(2);
                                                }}
                                            >
                                                {viewType === 2 ? 
                                                    <img src="./images/icons/icon_view_grid_active.svg" width='18'/>
                                                    :
                                                    <img src="./images/icons/icon_view_grid.svg" width='18'/>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </>
                                :
                                <div className='mini_left_header'>
                                    <div className='mini_header'>
                                        <p className='title'>
                                            {memberinfos?.compony?.title}
                                        </p>

                                        <div style={{ width: is520 ? 140 : 140, flexShrink: 0 }}>
                                            <Button
                                                styles={{ height: 40 }}
                                                className={'normalbutton_middle'}
                                                buttonTxt={memberinfos?.compony?.miniorderbuttonText || '간편문의'}
                                                onPress={() => {
                                                    seteasyWrite(!easyWrite);
                                                }}

                                            />
                                        </div>
                                    </div>

                                    <div className='select_type_list'>
                                        <div className='flex_list_type'>
                                            <p className={listType === 1 ? 'active' : ''} onClick={() => {
                                                setListType(1);
                                            }}>기본순</p>
                                            <div className='bar_icon_div' />
                                            <p className={listType === 2 ? 'active' : ''} onClick={() => {
                                                setListType(2);
                                            }}>등록순</p>
                                            <div className='bar_icon_div' />
                                            <p className={listType === 3 ? 'active' : ''} onClick={() => {
                                                setListType(3);
                                            }}>가격순</p>
                                            <div className='bar_icon_div' />
                                            <p className={listType === 4 ? 'active' : ''} onClick={() => {
                                                setListType(4);
                                            }}>면적순</p>
                                        </div>

                                        <div className='icon_img_type'>
                                            <div
                                                className='icon_box'
                                                onClick={() => {
                                                    setViewType(1);
                                                }}
                                            >
                                                {viewType === 1 ? 
                                                    <img src="./images/icons/icon_view_list_active.svg" width='24'/>
                                                    :
                                                    <img src="./images/icons/icon_view_list.svg" width='24'/>
                                                }
                                            </div>
                                            <div className='bar_icon_div' />
                                            <div
                                                className='icon_box'
                                                onClick={() => {
                                                    setViewType(2);
                                                }}
                                            >
                                                {viewType === 2 ? 
                                                    <img src="./images/icons/icon_view_grid_active.svg" width='24'/>
                                                    :
                                                    <img src="./images/icons/icon_view_grid.svg" width='24'/>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            <MiniPageList
                                viewType={viewType}
                                memberinfos={memberinfos}
                                listloading={listloading}
                                list={productlistTd}
                                onCardClick={(cardItem) => {
                                    //getAddressToGeoCode(cardItem.addr, (geoCode) => {
                                        console.log("geoCodegeoCode", cardItem?.lat, cardItem?.lng);
                                        //setlatlng(geoCode)
                                        setlatlng({lat: cardItem?.lat, lng: cardItem?.lng})
                                    //})
                                }}
                            />

                        </div>
                    }

                    <MiniPageMap
                        latlng={latlng}
                        memberinfos={memberinfos}
                        positionLists={positions}
                        showbtn={is830}
                        show={listShow}
                        setShow={() => {
                            setListShow(!listShow);
                        }}
                        // 매물 종류
                        configArr={configArr}
                        setConfigArr={setConfigArr}
                        setConfigReset={() => { // 매물종류 초기화
                            setConfigArr([]);
                        }}

                        // 거래 유형/가격
                        sell_type={sell_type} // 매매 전세 월세
                        setsell_type={(val) => {
                            setsell_type(val);
                        }}
                        sell_type_list={sell_type_list}
                        setsell_type_list={setsell_type_list}
                        price_sell_min={price_sell_min} // 매매가 최소
                        setprice_sell_min={setprice_sell_min}
                        price_sell_max={price_sell_max} // 매매가 최대
                        setprice_sell_max={setprice_sell_max}
                        price_all_min={price_all_min} // 전세 보증금 최소
                        setprice_all_min={setprice_all_min}
                        price_all_max={price_all_max} // 전세 보증금 최대
                        setprice_all_max={setprice_all_max}
                        price_all_month_min={price_all_month_min} // 월세 보증금 최소
                        setprice_all_month_min={setprice_all_month_min}
                        price_all_month_max={price_all_month_max} // 월세 보증금 최대
                        setprice_all_month_max={setprice_all_month_max}
                        price_month_min={price_month_min} // 월세 최소
                        setprice_month_min={setprice_month_min}
                        price_month_max={price_month_max} // 월세 최대
                        setprice_month_max={setprice_month_max}

                        // 면적, 방수, 층
                        area_type={area_type} // 1=평, 2=m²
                        setarea_type={setarea_type}
                        area_private_min={area_private_min} // 전용면적 최소
                        setarea_private_min={setarea_private_min}
                        area_private_max={area_private_max} // 전용면적 최대
                        setarea_private_max={setarea_private_max}
                        item_room={item_room} // 방수 1=1개, 2=2개, 3=3개, 4=4개 이상
                        setitem_room={setitem_room}
                        item_room_list={item_room_list}
                        setitem_room_list={setitem_room_list}
                        building_floor_min={building_floor_min} // 희망층 최소
                        setbuilding_floor_min={setbuilding_floor_min}
                        building_floor_max={building_floor_max} // 희망층 최대
                        setbuilding_floor_max={setbuilding_floor_max}

                        floor_config={floor_config}
                        building_floor_arr={building_floor_arr} // 희망층 idx배열
                        setbuilding_floor_arr={setbuilding_floor_arr}

                        area_floor_min={area_floor_min} // 건물 연면적 최소
                        setarea_floor_min={setarea_floor_min}
                        area_floor_max={area_floor_max} // 건물 연면적 최대
                        setarea_floor_max={setarea_floor_max}
                        area_land_min={area_land_min} // 토지면적 최소
                        setarea_land_min={setarea_land_min}
                        area_land_max={area_land_max} // 토지면적 최대
                        setarea_land_max={setarea_land_max}
                        building_dong_floor_all_min={building_dong_floor_all_min} // 희망 총 층수 최소
                        setbuilding_dong_floor_all_min={setbuilding_dong_floor_all_min}
                        building_dong_floor_all_max={building_dong_floor_all_max} // 희망 총 층수 최대
                        setbuilding_dong_floor_all_max={setbuilding_dong_floor_all_max}


                        clusterIdx={selPosList}
                        setClusterIdx={(val, mobileUrl='') => {
                            setselPosList(val)
                            mapFilterClurFunc(val);

                            if(mobileUrl) {
                                mobileBackControl(mobileUrl);
                            }
                        }}
                        setClusterReset={() => {
                            filterFunc();
                        }}
                        filterFunc={() => {
                            filterFunc();
                        }}
                        mobileBackControl={(res) => {
                            mobileBackControl(res);
                        }}
                    />
                </>

            </div>

            {/* ITEM_MINI_TB로 저장됨 */}
            {easyWrite &&
                <QuetionSimpleWrite
                    setView={() => {
                        seteasyWrite(!easyWrite);
                    }}
                    memberinfos={memberinfos}
                // setsimplewrite={setsimplewrite}
                // setselltypeproduct={setsell_type}
                // setcategory_1product={setcategory_1}
                // setcategory_2product={setcategory_2}
                />
            }

        </>
    )
}
